module.exports = __webpack_public_path__ + "img/logo_beritabaru.ba356b5e.png";